import module from 'nominas/finiquito/module.js'
import template from './template.html'
import { orderBy } from 'lodash'

export class NominasFiniquitoEscenarioConceptosComponent {
  data
  editable
  conceptos
  salarioDiario
  idNaturaleza
  onChange
  conceptosDisponibles = []
  conceptosIndex = {}
  extendido = false

  $onChanges (changes) {
    if (changes.conceptos) {
      this.conceptosIndex = this.conceptos
        .reduce((conceptosIndex, item) => {
          conceptosIndex[item.id] = item

          return conceptosIndex
        }, {})
    }

    if (changes.data) {
      this.generarData()
      this.calcularConceptosDisponibles()
    }
  }

  agregarConcepto (data) {
    this.agregando = false

    if (!Array.isArray(data) || !data.length) return

    this.data = this.data.concat(data)
    this.generarData()
    this.calcularConceptosDisponibles()
    this.modificado()
  }

  calcularConceptosDisponibles () {
    this.conceptosDisponibles = this.conceptos.filter((item) => !this.data.find((concepto) => concepto.id_concepto === Number(item.id)))
  }

  eliminarConcepto (item) {
    this.data.splice(this.data.indexOf(item), 1)
    this.calcularConceptosDisponibles()
    this.modificado()
  }

  modificarConcepto (item, data) {
    this.data.splice(this.data.indexOf(item), 1, data)
    this.modificado()
  }

  modificado () {
    this.onChange({$event: {data: this.data}})
  }

  generarData () {
    this.data.forEach((item) => {
      if (item.descripcion) return

      let concepto = this.conceptosIndex[item.id_concepto]

      if (!concepto) return

      item.descripcion = concepto.concepto
      item.editable = concepto.editable
      item.id_tipo_concepto = concepto.id_tipo_concepto
      item.calculo_importe = concepto.calculo_importe
    })

    this.data = orderBy(this.data, ['descripcion'])
  }
}

module.component('nominasFiniquitoEscenarioConceptos', {
  controller: NominasFiniquitoEscenarioConceptosComponent,
  template,
  bindings: {
    data: '<',
    editable: '<',
    conceptos: '<',
    salarioDiario: '<',
    idNaturaleza: '@',
    onChange: '&',
  },
})



// WEBPACK FOOTER //
// ./src/nominas/finiquito/components/escenario/conceptos/component.js